/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';

import { mergeStyles } from '@cian/utils';

import * as styles from './index.css';

export interface IIconedLinkProps {
  text: string;
  link: string;
  icon: JSX.Element;
  isDisabled?: boolean;
  onClick?(): void;
}

export const IconedLink = (props: IIconedLinkProps) => (
  <a
    {...mergeStyles(styles['container'], props.isDisabled && styles['container--disabled'])}
    href={props.link}
    target="_blank"
    onClick={props.onClick}
  >
    {props.icon}
    <span className={styles['text']}>{props.text}</span>
  </a>
);
